import { Button } from '@/platform/ui';
import {
    Dialog,
    DialogBackdrop,
    DialogPanel,
    DialogTitle,
} from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { router } from '@inertiajs/react';
import { useEffect, useState } from 'react';

// history.length also counts pages from other sites in this tab, so count the
// app's own visits instead: the first one is the page the panel was opened on.
let visits = 0;

router.on('navigate', () => {
    visits += 1;
});

export const closePanel = fallbackUrl =>
    visits > 1 ? window.history.back() : router.visit(fallbackUrl);

const SidePanel = ({ title, subtitle, onClose, footer, children }) => {
    const [open, setOpen] = useState(false);

    useEffect(() => setOpen(true), []);

    return (
        <Dialog open={open} onClose={onClose} className='relative z-50'>
            <DialogBackdrop
                transition
                className='fixed inset-0 bg-gray-900/70 backdrop-blur-md transition data-closed:opacity-0'
            />
            <div className='fixed inset-0 flex justify-end'>
                <DialogPanel
                    transition
                    className='flex h-full w-full max-w-xl flex-col bg-white shadow-xl transition data-closed:translate-x-full'
                >
                    <div className='flex items-start justify-between gap-4 border-b border-gray-200 px-6 py-4'>
                        <div>
                            <DialogTitle className='flex items-center gap-2 text-base font-semibold text-gray-900'>
                                {title}
                            </DialogTitle>
                            {subtitle && (
                                <p className='text-sm text-gray-500'>
                                    {subtitle}
                                </p>
                            )}
                        </div>
                        <Button
                            type='button'
                            variant='link'
                            aria-label='Sluiten'
                            onClick={onClose}
                        >
                            <XMarkIcon className='size-5 text-gray-500' />
                        </Button>
                    </div>

                    <div className='flex flex-1 flex-col gap-4 overflow-y-auto px-6 py-4'>
                        {children}
                    </div>

                    {footer && (
                        <div className='flex flex-col gap-3 border-t border-gray-200 px-6 py-4'>
                            {footer}
                        </div>
                    )}
                </DialogPanel>
            </div>
        </Dialog>
    );
};

export default SidePanel;
